import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

const ARCHIVE_URL = environment.serverUrl + '/traces/archive';

export type TraceArchiveProtocol = 'OCPP' | 'OKECHARGE';

export interface TraceArchiveSummary {
  protocol: TraceArchiveProtocol;
  month: string;
  from: string;
  to: string;
  count: number;
  estimatedBytes: number;
}

export interface TraceArchiveBatchDeletion {
  deleted: number;
}

@Injectable({ providedIn: 'root' })
export class TraceArchiveApiService {

  constructor(private http: HttpClient) { }

  public summary(protocol: TraceArchiveProtocol, month: string): Observable<TraceArchiveSummary> {
    return this.http.get<TraceArchiveSummary>(`${ARCHIVE_URL}/summary`, { params: this.params(protocol, month) });
  }

  public deleteBatch(protocol: TraceArchiveProtocol, month: string): Observable<TraceArchiveBatchDeletion> {
    return this.http.delete<TraceArchiveBatchDeletion>(ARCHIVE_URL, { params: this.params(protocol, month) });
  }

  public exportUrl(protocol: TraceArchiveProtocol, month: string): string {
    return `${ARCHIVE_URL}/export?${this.params(protocol, month).toString()}`;
  }

  private params(protocol: TraceArchiveProtocol, month: string): HttpParams {
    return new HttpParams().set('protocol', protocol).set('month', month);
  }
}
